
import Form from 'react-bootstrap/Form';
import './UserForm.scss'
import { User } from "../../../utils/models/User";
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { AdminUser } from '../../../utils/const';
import { AWSelect } from 'aw-select';
import { useTheme } from '../../../utils/contexts/ThemeContext';
import { InputGroup } from 'react-bootstrap';
import { useState } from 'react';

const UserForm = (props: {
    formLock: boolean, edit: boolean; userAux: User, sendChange: (event: any) => void, optionsCompany: any, selectedCompany: any, onChangeSelectCompany: (e: any) => void,
    optionsUserRol: any, selectedUserRol: any, onChangeSelectUserRol: (e: any) => void,
    optionsUserLang: any, selectedUserLang: any, onChangeSelectUserLang: (e: any) => void
}) => {
    const { userAux } = props
    const [passwordError, setPasswordError] = useState("")
    const { t } = useTranslation();
    const onInputChange = (event: any) => {
        const { name, value } = event.target;
  if (name === "password") {
    if (!/^(?=.*[A-Za-z])(?=.*\d).{8,}$/.test(value)) {
      setPasswordError(t("PasswordMustContainAtLeast8Characters"));
    } else {
      setPasswordError("");
    }
  }
        props.sendChange(event)
    };

    const theme = useTheme();
    const dark = theme.theme==='dark';
    const [passwordVisibility, setPasswordVisibility] = useState(false)
    return (
        <div className="p-3 rounded-3" id='formUserContainer'>
            <Form>
                <div className="row mb-1 mt-2">
                    <div className="col">
                        <Form.Check disabled={props.formLock} name="active" type="checkbox" label={t('Active')} defaultChecked={userAux.active} onClick={onInputChange} />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{`${t('Name')}*`}</Form.Label>
                        <Form.Control disabled={props.formLock} name="name" type="text" className="inputStyle" onChange={onInputChange} value={userAux.name} />
                    </div>
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('Surnames')}</Form.Label>
                        <Form.Control disabled={props.formLock} name="surname" type="text" className="inputStyle" onChange={onInputChange} value={userAux.surname} />
                    </div>
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{`${t('Email')}*`}</Form.Label>
                        <Form.Control disabled={props.formLock || userAux.iduser > 0} name="email" className="inputStyle" type="text" onChange={onInputChange} value={userAux.email} />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('Phone')}</Form.Label>
                        <Form.Control disabled={props.formLock} name="phone" type="text" className="inputStyle" onChange={onInputChange} value={userAux.phone} />
                    </div>
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('Company')}</Form.Label>
                        <AWSelect dark={dark} disabled={props.formLock} closeMenuOnSelect={true} className="inputStyle selectStyle" defaultValue={props.selectedCompany} onChange={props.onChangeSelectCompany} options={props.optionsCompany} />
                    </div>
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>Rol</Form.Label>
                        <AWSelect dark={dark} disabled={props.formLock || userAux.email === AdminUser} className="inputStyle selectStyle" closeMenuOnSelect={true} defaultValue={props.selectedUserRol} onChange={props.onChangeSelectUserRol} options={props.optionsUserRol} />

                    </div>
                </div>
                <div className="row mb-5">
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('Language')}</Form.Label>
                        <AWSelect dark={dark} disabled={props.formLock} closeMenuOnSelect={true} className="inputStyle selectStyle" defaultValue={props.selectedUserLang} onChange={props.onChangeSelectUserLang} options={props.optionsUserLang} />

                    </div>
                    <div className="col">

                    </div>
                    <div className="col">
                    </div>
                </div>
                <div className='row mb-3'>
                    <div className='col-12 col-lg'>
                        <Form.Label className='mb-0'>{`${t("Password")}*`}</Form.Label>
                        <InputGroup className='password'>
                            <Form.Control disabled={props.formLock || userAux.iduser > 0} className={`inputStyle ${passwordError ? "is-invalid" : ""}`} name='password' type={!(props.formLock || userAux.iduser > 0) && passwordVisibility ? "text" : "password"} onChange={onInputChange} value={userAux.password} />
                            {!(props.formLock || userAux.iduser > 0) && (
                                <InputGroup.Text onClick={() => setPasswordVisibility(!passwordVisibility)}>
                                    <i className={passwordVisibility ? "bi bi-eye-slash" : "bi bi-eye"} >
                                        {" "}
                                    </i>
                                </InputGroup.Text>
                            )}
                        </InputGroup>
                            {passwordError && <div className="invalid-feedback d-block">{passwordError}</div>}
                    </div>
                    <div className="col">
                    </div>
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('LastConection')}</Form.Label>
                        <Form.Control disabled={true} name="last_conection" type="text" className="inputStyle" value={(userAux.iduser > 0) ? format(new Date(userAux.last_conection), "dd/MM/yyyy HH:mm:ss") : ''} />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col">
                    </div>
                    <div className="col">
                    </div>
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('CreationDate')}</Form.Label>
                        <Form.Control disabled={true} name="creation_date" type="text" className="inputStyle" value={(userAux.iduser > 0) ? format(new Date(userAux.createdAt), "dd/MM/yyyy HH:mm:ss") : ''} />
                    </div>
                </div>
            </Form>
        </div>
    )
}
export default UserForm;